import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { emailConfirmation } from 'store/user';
import { 
  Result, 
  Card, 
  Typography, 
  theme
} from 'antd';
import { 
  CheckCircleOutlined
} from '@ant-design/icons';
import logo from 'assets/images/DSman_logo_blue_dark.svg';
import styles from './index.module.css';
const { Title, Text } = Typography;

export default function EmailConfirmation() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { token } = theme.useToken();
  
  // Get the API response message from Redux state
  const emailConfirmationData = useSelector(state => state.user?.emailConfirmation);
  const apiMessage = emailConfirmationData?.message;

  const formattedMessage = useMemo(() => {
    if (!apiMessage) return null;
    // Find first period to split the message
    const firstPeriodIndex = apiMessage.indexOf('.')
    const beforePeriod = firstPeriodIndex === -1 ? apiMessage : apiMessage.slice(0, firstPeriodIndex)
    const afterPeriod = firstPeriodIndex === -1 ? '' : apiMessage.slice(firstPeriodIndex)

    const toIndex = beforePeriod.lastIndexOf(' to ')
    if (toIndex === -1) {
      return <span>{apiMessage}</span>
    }

    const prefix = beforePeriod.slice(0, toIndex + 4)
    const highlight = beforePeriod.slice(toIndex + 4)

    return (
      <>
        {prefix}
        <span style={{ color: token.colorPrimary, fontWeight: 600 }}>{highlight}</span>
        {afterPeriod}
      </>
    )
  }, [apiMessage, token.colorPrimary]);

  useEffect(() => {
    dispatch(emailConfirmation({ id }));
  }, [id]);

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {/* Logo */}
        <div className={styles.logoContainer}>
          <img src={logo} alt="Digital Sportsman logo" className={styles.logo} />
        </div>
        
        {/* Main Result Card */}
        <Card className={styles.mainCard}>
          <Result
            icon={<CheckCircleOutlined style={{ color: token.colorSuccess }} />}
            title={<Title level={2} style={{ margin: 0 }}>Email Sent!</Title>}
            subTitle={
              <Text type="secondary" style={{ fontSize: '16px', textAlign: 'center' }}>
                {formattedMessage || ""}
              </Text>
            }
          />
        </Card>
      </div>
    </div>
  );
}